import APIClient from '@/shared/http/clients/api'

const resourceName = 'consorcio'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

/**
 * @name CarteiraConsorcioRepository
 * @description Captação Remunerada Diária
 * @type { Respository }
 */
const CarteiraConsorcioRepository = {
  Search
}

export default CarteiraConsorcioRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/carteiraconsorcio.js